/**
 * Common formatting utilities
 */

/**
 * Format currency value
 */
export const formatCurrency = (value, options = {}) => {
  if (value === null || value === undefined || value === '') return '-';
  const n = parseFloat(value);
  if (isNaN(n)) return '-';
  
  const defaultOptions = {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  };

  return new Intl.NumberFormat('en-US', { ...defaultOptions, ...options }).format(n);
};

/**
 * Format date to MM/DD/YYYY
 */
export const formatDate = (value) => {
  if (!value) return '-';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '-';
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const yy = d.getFullYear();
  return `${mm}/${dd}/${yy}`;
};

/**
 * Format date for email display (short format)
 */
export const formatDateForEmail = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
  });
};

/**
 * Format date and time with timezone
 */
export const formatDateTime = (dateString) => {
  const date = new Date(dateString);
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  
  return {
    fullDateTime: date.toLocaleString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
      timeZone
    }),
    timeZone: timeZone.replace(/_/g, ' ')
  };
};

/**
 * Format percentage
 */
export const formatPercentage = (value) => {
  if (!value) return '-';
  return `${value}%`;
};

/**
 * Format phone number
 */
export const formatPhoneNumber = (phoneNumberString) => {
  if (!phoneNumberString) return '';
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return phoneNumberString;
};

/**
 * Truncate text
 */
export const truncateText = (text, maxLength = 50) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

